(() => {
  const config = () => window.Everelle || {};
  const root = () => config().root || "/";
  const text = (key) => config().strings?.[key] || key;
  const status = (message) => {
    const node = document.getElementById("StoreStatus");
    if (node) node.textContent = message;
  };
  const money = (cents) => {
    const format = (config().moneyFormat || "{{amount}}").replace(
      /<[^>]*>/g,
      "",
    );
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, token) => {
      const decimals = token.includes("no_decimals") ? 0 : 2;
      const value = (Number(cents) / 100).toLocaleString("en-US", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
      return token.includes("comma_separator")
        ? value.replace(/,/g, "#").replace(".", ",").replace(/#/g, ".")
        : value;
    });
  };
  async function jsonRequest(url, options = {}) {
    const response = await fetch(url, {
      headers: { Accept: "application/json", ...options.headers },
      ...options,
    });
    const result = await response.json();
    if (!response.ok || result.status >= 400)
      throw new Error(
        typeof result.description === "string"
          ? result.description
          : typeof result.message === "string"
            ? result.message
            : text("error"),
      );
    return result;
  }
  function closeDialog(dialog) {
    if (dialog?.open) dialog.close();
  }
  function openDialog(dialog) {
    if (dialog && !dialog.open) dialog.showModal();
  }
  function genericDialog(className, children) {
    const dialog = document.getElementById("store-dialog");
    if (!dialog) return;
    dialog.className = `theme-dialog modal ${className}`;
    dialog.querySelector("[data-dialog-content]").replaceChildren(...children);
    openDialog(dialog);
  }
  function imageNode(url, alt) {
    const image = new Image();
    image.src = url;
    image.alt = alt || "";
    return image;
  }
  function showNote(button) {
    const image = imageNode(button.dataset.noteImage, button.dataset.noteTitle);
    image.className = "note-hero";
    const content = document.createElement("div");
    content.className = "note-content";
    const heading = document.createElement("h2");
    heading.textContent = button.dataset.noteTitle;
    const description = document.createElement("p");
    description.textContent = button.dataset.noteText;
    content.append(heading, description);
    genericDialog("theme-notes-modal", [image, content]);
  }
  function setGallery(gallery, index) {
    const media = [...gallery.querySelectorAll("[data-media-id]")];
    if (!media.length) return;
    index = (index + media.length) % media.length;
    gallery.dataset.activeIndex = index;
    media.forEach((item, i) => {
      item.classList.toggle("is-active", i === index);
      if (i !== index)
        item.querySelectorAll("video").forEach((video) => video.pause());
    });
    gallery.querySelectorAll("[data-gallery-target]").forEach((button) => {
      const active =
        button.dataset.galleryTarget === media[index].dataset.mediaId;
      button.classList.toggle("selected", active);
      button.setAttribute("aria-pressed", active);
    });
    const count = gallery.querySelector("[data-gallery-counter]");
    if (count) count.textContent = `${index + 1} / ${media.length}`;
  }
  function initGallery(scope) {
    scope
      .querySelectorAll("[data-gallery]:not([data-initialized])")
      .forEach((gallery) => {
        gallery.dataset.initialized = "true";
        setGallery(gallery, 0);
        let startX;
        const main = gallery.querySelector(".gallery-main");
        main?.addEventListener("pointerdown", (e) => {
          if (e.pointerType === "touch") startX = e.clientX;
        });
        main?.addEventListener("pointerup", (e) => {
          if (startX === undefined) return;
          const distance = e.clientX - startX;
          startX = undefined;
          if (Math.abs(distance) > 45)
            setGallery(
              gallery,
              Number(gallery.dataset.activeIndex || 0) +
                (distance < 0 ? 1 : -1),
            );
        });
      });
  }
  function setHero(hero, index) {
    const slides = [...hero.querySelectorAll("[data-slide]")];
    if (!slides.length) return;
    index = (index + slides.length) % slides.length;
    hero.dataset.activeSlide = index;
    slides.forEach((slide, i) =>
      slide.classList.toggle("is-active", i === index),
    );
    hero.querySelectorAll("[data-hero-dot]").forEach((dot, i) => {
      dot.classList.toggle("selected", i === index);
      dot.setAttribute("aria-pressed", i === index);
    });
  }
  function updateProduct(section) {
    let product;
    try {
      product = JSON.parse(
        section.querySelector("[data-product-json]").textContent,
      );
    } catch {
      return;
    }
    const form = section.querySelector("[data-product-form]");
    if (!form) return;
    const options = [...form.querySelectorAll("[data-variant-option]")]
      .filter((input) => input.tagName === "SELECT" || input.checked)
      .sort(
        (a, b) =>
          Number(a.dataset.variantOption) - Number(b.dataset.variantOption),
      )
      .map((input) => input.value);
    const variant = options.length
      ? product.variants.find((v) =>
          v.options.every((value, index) => value === options[index]),
        )
      : product.variants[0];
    const input = form.querySelector('[name="id"]');
    input.disabled = !variant;
    if (variant) input.value = variant.id;
    section
      .querySelectorAll("[data-add-button],[data-sticky-add]")
      .forEach((button) => {
        const sampleBlocked = section.dataset.sampleBlocked === 'true';
        button.disabled = sampleBlocked || !variant?.available;
        const label = sampleBlocked ? text('sample') : variant
          ? variant.available
            ? text("add")
            : text("soldOut")
          : text("unavailable");
        if (button.hasAttribute("data-sticky-add")) {
          button.replaceChildren(document.createTextNode(label));
          if (variant) {
            const span = document.createElement("span");
            span.dataset.stickyPrice = "";
            span.textContent = money(variant.price);
            button.append(span);
          }
        } else button.textContent = label;
      });
    const price = section.querySelector("[data-product-price]");
    if (price && variant) price.textContent = money(variant.price);
    const compare = section.querySelector("[data-compare-price]");
    if (compare) {
      compare.hidden = !variant || !(variant.compare_at_price > variant.price);
      if (!compare.hidden)
        compare.textContent = money(variant.compare_at_price);
    }
    const title = section.querySelector("[data-selected-variant-title]");
    if (title)
      title.textContent =
        variant && variant.title !== "Default Title"
          ? `(${variant.title})`
          : "";
    if (variant) {
      const url = new URL(location.href);
      url.searchParams.set("variant", variant.id);
      history.replaceState({}, "", url);
      if (variant.featured_media?.id) {
        const gallery = section.querySelector("[data-gallery]");
        const index = [
          ...gallery.querySelectorAll("[data-media-id]"),
        ].findIndex(
          (media) =>
            media.dataset.mediaId === String(variant.featured_media.id),
        );
        if (index >= 0) setGallery(gallery, index);
      }
    }
  }
  async function refreshCart(open = false) {
    const response = await fetch(`${root()}?section_id=cart-drawer`, {
      headers: { Accept: "text/html" },
    });
    if (!response.ok) throw new Error(text("error"));
    const documentFragment = new DOMParser().parseFromString(
      await response.text(),
      "text/html",
    );
    const replacement = documentFragment.getElementById("CartDrawer");
    const drawer = document.getElementById("CartDrawer");
    if (!replacement || !drawer) throw new Error(text("error"));
    drawer.innerHTML = replacement.innerHTML;
    const cart = await jsonRequest(`${root()}cart.js`);
    document.querySelectorAll("[data-cart-count]").forEach((node) => {
      node.textContent = cart.item_count;
      node.hidden = cart.item_count === 0;
    });
    if (open) openDialog(drawer);
    status(text("cartUpdated"));
    return cart;
  }
  async function addToCart(form) {
    const button = form.querySelector("[data-add-button]");
    const error = form.querySelector("[data-product-error]");
    if (button?.disabled) return;
    if (error) error.hidden = true;
    if (button) button.disabled = true;
    try {
      await jsonRequest(`${root()}cart/add.js`, {
        method: "POST",
        body: new FormData(form),
      });
      await refreshCart(true);
    } catch (exception) {
      if (error) {
        error.textContent = exception.message;
        error.hidden = false;
      } else status(exception.message);
    } finally {
      if (button) button.disabled = false;
    }
  }
  async function changeCart(key, quantity) {
    const drawer = document.getElementById("CartDrawer");
    try {
      await jsonRequest(`${root()}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: key,
          quantity: Math.max(0, Number(quantity)),
        }),
      });
      if (document.body.classList.contains("template-cart")) {
        location.reload();
        return;
      }
      await refreshCart(drawer?.open);
    } catch (exception) {
      const error = drawer?.querySelector("[data-cart-error]");
      if (error) {
        error.hidden = false;
        error.textContent = exception.message;
      }
      status(exception.message);
    }
  }
  function readWishlist() {
    try {
      const value = JSON.parse(
        localStorage.getItem("everelle-theme-wishlist-v1"),
      );
      return Array.isArray(value) ? value : [];
    } catch {
      return [];
    }
  }
  function renderWishlist() {
    const items = readWishlist();
    document.querySelectorAll("[data-wishlist-toggle]").forEach((button) => {
      const saved = items.some((item) => item.handle === button.dataset.handle);
      button.classList.toggle("active", saved);
      button.setAttribute("aria-pressed", saved);
    });
    const grid = document.querySelector("[data-wishlist-grid]");
    if (!grid) return;
    grid.replaceChildren();
    const empty = document.querySelector("[data-wishlist-empty]");
    if (empty) empty.hidden = items.length > 0;
    items.forEach((item) => {
      if (
        !item.url?.startsWith("/") ||
        !item.image ||
        !/^(https?:)?\/\//.test(item.image)
      )
        return;
      const card = document.createElement("article");
      card.className = "product-card";
      const imageLink = document.createElement("a");
      imageLink.href = item.url;
      imageLink.className = "card-image";
      imageLink.append(imageNode(item.image, item.title));
      const copy = document.createElement("div");
      copy.className = "card-copy";
      const title = document.createElement("a");
      title.href = item.url;
      const heading = document.createElement("strong");
      heading.textContent = item.title;
      title.append(heading);
      const price = document.createElement("b");
      price.textContent = item.price;
      const remove = document.createElement("button");
      remove.className = "remove";
      remove.textContent = config().strings?.remove || "Remove";
      remove.dataset.wishlistRemove = item.handle;
      copy.append(title, price, remove);
      card.append(imageLink, copy);
      grid.append(card);
    });
  }
  function toggleWishlist(button) {
    const items = readWishlist();
    const index = items.findIndex(
      (item) => item.handle === button.dataset.handle,
    );
    if (index >= 0) items.splice(index, 1);
    else
      items.push({
        handle: button.dataset.handle,
        title: button.dataset.title,
        url: button.dataset.url,
        image: button.dataset.image,
        price: button.dataset.price,
      });
    try {
      localStorage.setItem("everelle-theme-wishlist-v1", JSON.stringify(items));
    } catch {
      status(text("error"));
    }
    renderWishlist();
  }
  function selectSample(handle, updateUrl = false) {
    const samples = [...document.querySelectorAll("[data-sample-product]")];
    if (!samples.length) return;
    const selected =
      samples.find((sample) => sample.dataset.sampleProduct === handle) ||
      samples[0];
    samples.forEach((sample) => {
      sample.hidden = sample !== selected;
    });
    if (updateUrl) {
      const url = new URL(location.href);
      url.searchParams.set("sample", selected.dataset.sampleProduct);
      history.replaceState({}, "", url);
    }
  }
  function sortSamples(select) {
    const grid = select.closest('.collection')?.querySelector('.collection-grid');
    if (!grid) return;
    const cards = [...grid.querySelectorAll('[data-sample-card]')];
    const order = select.value;
    cards.sort((a, b) => {
      if (order === 'price-ascending' || order === 'price-descending')
        return (Number(a.dataset.samplePrice) - Number(b.dataset.samplePrice)) * (order === 'price-descending' ? -1 : 1);
      if (order === 'title-ascending' || order === 'title-descending')
        return a.dataset.sampleTitle.localeCompare(b.dataset.sampleTitle) * (order === 'title-descending' ? -1 : 1);
      return 0;
    });
    grid.append(...cards);
  }
  function updateCarousels(scope = document) {
    scope.querySelectorAll('[data-carousel]').forEach(track => {
      const arrow = track.closest('.row-wrap')?.querySelector('[data-carousel-next]');
      if (arrow) arrow.hidden = track.scrollWidth <= track.clientWidth + 1;
    });
  }
  function init(scope = document) {
    initGallery(scope);
    scope
      .querySelectorAll("[data-hero]")
      .forEach((hero) => setHero(hero, Number(hero.dataset.activeSlide || 0)));
    selectSample(new URLSearchParams(location.search).get("sample"));
    scope.querySelectorAll('[data-sort-samples]').forEach(sortSamples);
    updateCarousels(scope);
    renderWishlist();
  }
  document.addEventListener("click", (event) => {
    const target = event.target.closest("button,a");
    if (!target) return;
    if (target.hasAttribute("data-close-dialog")) {
      closeDialog(target.closest("dialog"));
      return;
    }
    if (target.hasAttribute("data-open-cart")) {
      event.preventDefault();
      refreshCart(true).catch(() => {
        location.href = config().cart;
      });
      return;
    }
    if (target.hasAttribute("data-cart-change")) {
      event.preventDefault();
      changeCart(target.dataset.cartChange, target.dataset.quantity);
      return;
    }
    if (target.hasAttribute("data-wishlist-toggle")) {
      event.preventDefault();
      toggleWishlist(target);
      return;
    }
    if (target.hasAttribute("data-wishlist-remove")) {
      try {
        localStorage.setItem(
          "everelle-theme-wishlist-v1",
          JSON.stringify(
            readWishlist().filter(
              (item) => item.handle !== target.dataset.wishlistRemove,
            ),
          ),
        );
      } catch {}
      renderWishlist();
      return;
    }
    if (target.hasAttribute("data-carousel-next")) {
      target.parentElement
        .querySelector("[data-carousel]")
        ?.scrollBy({
          left: target.parentElement.clientWidth * 0.85,
          behavior: "smooth",
        });
      return;
    }
    if (target.hasAttribute("data-back-top")) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    if (target.hasAttribute("data-hero-next")) {
      const hero = target.closest("[data-hero]");
      setHero(hero, Number(hero.dataset.activeSlide || 0) + 1);
      return;
    }
    if (target.hasAttribute("data-hero-dot")) {
      setHero(target.closest("[data-hero]"), Number(target.dataset.heroDot));
      return;
    }
    if (target.hasAttribute("data-gallery-target")) {
      const gallery = target.closest("[data-gallery]");
      const media = [...gallery.querySelectorAll("[data-media-id]")];
      setGallery(
        gallery,
        media.findIndex(
          (item) => item.dataset.mediaId === target.dataset.galleryTarget,
        ),
      );
      return;
    }
    if (target.hasAttribute("data-gallery-step")) {
      const gallery = target.closest("[data-gallery]");
      setGallery(
        gallery,
        Number(gallery.dataset.activeIndex || 0) +
          Number(target.dataset.galleryStep),
      );
      return;
    }
    if (target.hasAttribute("data-zoom-image")) {
      const image = imageNode(
        target.dataset.zoomImage,
        target.querySelector("img")?.alt,
      );
      image.className = "zoom-image";
      genericDialog("theme-gallery-modal", [image]);
      return;
    }
    if (target.hasAttribute("data-note-title")) {
      showNote(target);
      return;
    }
    if (target.hasAttribute("data-share-product")) {
      const url = new URL(location.href);
      url.searchParams.delete("preview_theme_id");
      url.searchParams.delete("_fd");
      navigator.clipboard
        ?.writeText(url.toString())
        .then(() => status(text("copied")))
        .catch(() => {});
      return;
    }
    if (target.hasAttribute("data-sample-select")) {
      event.preventDefault();
      selectSample(target.dataset.sampleSelect, true);
      return;
    }
    if (target.hasAttribute("data-sample-size")) {
      const sample = target.closest("[data-sample-product]");
      sample.querySelector("[data-sample-price]").textContent = money(
        target.dataset.price,
      );
      sample.querySelector("[data-sample-size-title]").textContent =
        `(${target.dataset.sampleSize})`;
      sample.querySelectorAll("[data-sample-size]").forEach((button) => {
        button.classList.toggle("selected", button === target);
        button.setAttribute("aria-pressed", button === target);
      });
    }
  });
  document.addEventListener("submit", (event) => {
    if (event.target.matches("[data-product-form]")) {
      event.preventDefault();
      addToCart(event.target);
    }
  });
  document.addEventListener("change", (event) => {
    if (event.target.matches("[data-variant-option]"))
      updateProduct(event.target.closest("[data-product-section]"));
    if (event.target.matches('[data-sort-samples]')) sortSamples(event.target);
    else if (event.target.matches("[data-sort-products]"))
      event.target.form.requestSubmit();
    if (event.target.matches("[data-cart-quantity]"))
      changeCart(event.target.dataset.cartQuantity, event.target.value);
    if (event.target.matches("#CartNote"))
      jsonRequest(`${root()}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: event.target.value }),
      }).catch(() => status(text("error")));
  });
  document.addEventListener("click", (event) => {
    if (event.target.tagName === "DIALOG") {
      const box = event.target.getBoundingClientRect();
      if (
        event.clientX < box.left ||
        event.clientX > box.right ||
        event.clientY < box.top ||
        event.clientY > box.bottom
      )
        closeDialog(event.target);
    }
  });
  document.addEventListener("shopify:section:load", (event) =>
    init(event.target),
  );
  document.addEventListener("shopify:block:select", (event) => {
    const slide = event.target.closest("[data-slide]");
    if (slide) {
      const hero = slide.closest("[data-hero]");
      setHero(hero, [...hero.querySelectorAll("[data-slide]")].indexOf(slide));
    }
    const sample = event.target.closest("[data-sample-product]");
    if (sample) selectSample(sample.dataset.sampleProduct);
  });
  window.addEventListener("storage", renderWishlist);
  window.addEventListener('resize', () => updateCarousels(), { passive: true });
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", () => init());
  else init();
})();
